import { ErrorPage } from '@components/error-page';
import { defCalRoute } from './common';

export const route = defCalRoute({ Page });

function Page() {
  return <ErrorPage title="404 | Not found" />;
}
